var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.572,
    height: 22.2,
    viewBox: "0 0 25.572 22.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1072 -2077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.463,35.142h0a.911.911,0,0,1,1.309.089c2.965,3.528,4.345,7.176,4.107,10.853a13.416,13.416,0,0,1-1.506,5.289L383,50.008a11.376,11.376,0,0,0,1.059-4.062c.2-3.186-1.038-6.392-3.684-9.541a.911.911,0,0,1,.084-1.262",
    transform: "translate(711.667 2043.914)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.315,87.277l.012-.01a.9.9,0,0,1,1.3.132c3.305,4.276,3.065,8.1,2.034,10.814l-1.424-1.42c.587-2.182.438-5.054-2.052-8.281a.9.9,0,0,1,.127-1.235",
    transform: "translate(748.788 1994.492)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.217,146.07a.911.911,0,0,1,1.349.165,6.7,6.7,0,0,1,1.208,4.929l-1.823-1.819a5.233,5.233,0,0,0-.88-2.071.912.912,0,0,1,.146-1.2",
    transform: "translate(784.894 1938.764)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.887,41.863a1.092,1.092,0,0,1,1.678.92v5.242l-4.423-4.412Z",
    transform: "translate(893.673 2037.485)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.238,121.326a1.092,1.092,0,0,1-1.644.941l-7.756-4.551a1.092,1.092,0,0,0-.552-.15H1.092A1.092,1.092,0,0,1,0,116.474V109.1a1.092,1.092,0,0,1,1.092-1.092H4.263a1.091,1.091,0,0,0,.587-.171l2.711-1.729,6.676,6.659Z",
    transform: "translate(1072 1976.427)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.383,275.666a.913.913,0,0,1-1.38.171l0,0a.913.913,0,0,1-.148-1.171,6.511,6.511,0,0,0,.4-.706l1.355,1.351q-.11.187-.224.359",
    transform: "translate(785.088 1817.335)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.187,325.182h0a.9.9,0,0,1-.023-1.194,10.106,10.106,0,0,0,.844-1.152l1.3,1.293a12.549,12.549,0,0,1-.756,1.017.9.9,0,0,1-1.362.035",
    transform: "translate(747.888 1771.005)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.327,419.342l0,0,.042.05Z",
    transform: "translate(706.776 1679.535)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.746,371.534a.911.911,0,0,1-1.355-.036l0,0a.909.909,0,0,1,.03-1.212,14.445,14.445,0,0,0,1.173-1.421l1.31,1.307a15.816,15.816,0,0,1-1.155,1.367",
    transform: "translate(710.713 1727.382)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.544,21.489a.574.574,0,0,1-.811,0L74.169.979a.574.574,0,1,1,.81-.813L95.543,20.678a.574.574,0,0,1,0,.811",
    transform: "translate(1001.86 2077)",
    fill: "#ff6633"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker2);
export default __webpack_public_path__ + "static/media/Speaker2.d07947eff1cc5a527a6331474c3a88cc.svg";
export { ForwardRef as ReactComponent };